import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import { toCamelCaseObj } from '../../../../utils/objectUtils';

import { fetchExportV4ApiKey, getAccessTokens } from './generalSettingsActions';
import { fetchExportV4ApiKeyRequest, getAccessTokensRequest } from './generalSettingsApi';
import { AccessTokens, FetchExportV4ApiKeyResponse } from './generalSettinsTypes';
import {
  setAccessTokens,
  setExportV4ApiKey,
  setExportV4ApiKeyLoading
} from './generalSettingsSlice';

function* fetchExportV4ApiKeySaga() {
  yield put(setExportV4ApiKeyLoading(true));

  try {
    const { api_key }: FetchExportV4ApiKeyResponse = yield call(fetchExportV4ApiKeyRequest);

    yield put(setExportV4ApiKey(api_key));
  } catch (error) {
    console.error(error);
  }

  yield put(setExportV4ApiKeyLoading(false));
}

function* getAccessTokensSaga(action: PayloadAction<string>) {
  const spotId = action.payload;

  try {
    const response = yield call(getAccessTokensRequest);
    const accessTokens = toCamelCaseObj(response) as AccessTokens;
    const result: Record<string, AccessTokens> = { [spotId]: accessTokens };

    yield put(setAccessTokens(result));
  } catch (error) {
    console.error(error);
  }
}

export function* generalSettingsSagas() {
  yield takeLatest(fetchExportV4ApiKey, fetchExportV4ApiKeySaga);
  yield takeLatest(getAccessTokens, getAccessTokensSaga);
}
